import { render } from "./roomList.vue?vue&type=template&id=fed3ece2&scoped=true"
import script from "./roomList.vue?vue&type=script&lang=js"
export * from "./roomList.vue?vue&type=script&lang=js"

import "./roomList.vue?vue&type=style&index=0&id=fed3ece2&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed3ece2"]])

export default __exports__